const context = {
  showSidebar: false,
  showMenu: false,
  showSectionTitle: true,
  started: false,
};

export default context;
